export default __webpack_public_path__ + "static/media/astro_guild.1df139cc.png";